import {
  ApprovalStatsSummary,
  ApprovalTableRow,
  emptyApprovalStats,
  HistoryStatusFilter,
  JobsTabKey,
  SuperAdminPendingApprovalJobs,
} from "../model/super_admin_jobs_model";
import { SuperAdminJobsPendingApprovalsAction } from "./super_admin_jobs_actions";

export interface SuperAdminJobPendingApprovalState {
  pendingApprovals: SuperAdminPendingApprovalJobs[];
  pendingCurrentPage: number;
  pendingRowsPerPage: number;
  pendingTotalCount: number;
  pendingLoading: boolean;
  pendingError: string | null;
  openMenuJobId: string | null;
  approvalHistory: ApprovalTableRow[];
  activeTab: JobsTabKey;
  historyStatusFilter: HistoryStatusFilter;
  historySearchTerm: string;
  currentPage: number;
  rowsPerPage: number;
  historyTotalCount: number;
  historyLoading: boolean;
  historyError: string | null;
  approvalStats: ApprovalStatsSummary;
}

export const initialState: SuperAdminJobPendingApprovalState = {
  pendingApprovals: [],
  pendingCurrentPage: 1,
  pendingRowsPerPage: 4,
  pendingTotalCount: 0,
  pendingLoading: false,
  pendingError: null,
  openMenuJobId: null,
  approvalHistory: [],
  activeTab: "pending",
  historyStatusFilter: "all",
  historySearchTerm: "",
  currentPage: 1,
  rowsPerPage: 4,
  historyTotalCount: 0,
  historyLoading: false,
  historyError: null,
  approvalStats: emptyApprovalStats,
};

export const SuperAdminJobPendingApprovalReducer = (
  state: SuperAdminJobPendingApprovalState,
  action: SuperAdminJobsPendingApprovalsAction
): SuperAdminJobPendingApprovalState => {
  switch (action.type) {
    case "SET_PENDING_APPROVALS":
      return { ...state, pendingApprovals: action.payload };
    case "SET_PENDING_CURRENT_PAGE":
      return { ...state, pendingCurrentPage: action.payload };
    case "SET_PENDING_ROWS_PER_PAGE":
      return {
        ...state,
        pendingRowsPerPage: action.payload,
        pendingCurrentPage: 1,
      };
    case "SET_PENDING_TOTAL_COUNT":
      return { ...state, pendingTotalCount: action.payload };
    case "SET_PENDING_LOADING":
      return { ...state, pendingLoading: action.payload };
    case "SET_PENDING_ERROR":
      return { ...state, pendingError: action.payload };
    case "SET_APPROVAL_HISTORY":
      return { ...state, approvalHistory: action.payload };
    case "SET_OPEN_MENU":
      return { ...state, openMenuJobId: action.payload };
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_HISTORY_STATUS_FILTER":
      return {
        ...state,
        historyStatusFilter: action.payload,
        currentPage: 1,
      };
    case "SET_HISTORY_SEARCH_TERM":
      return {
        ...state,
        historySearchTerm: action.payload,
        currentPage: 1,
      };
    case "CLEAR_HISTORY_FILTERS":
      return {
        ...state,
        historySearchTerm: "",
        historyStatusFilter: "all",
        currentPage: 1,
      };
    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_ROWS_PER_PAGE":
      return { ...state, rowsPerPage: action.payload, currentPage: 1 };
    case "SET_HISTORY_TOTAL_COUNT":
      return { ...state, historyTotalCount: action.payload };
    case "SET_HISTORY_LOADING":
      return { ...state, historyLoading: action.payload };
    case "SET_HISTORY_ERROR":
      return { ...state, historyError: action.payload };
    case "SET_APPROVAL_STATS":
      return { ...state, approvalStats: action.payload };
    default:
      return state;
  }
};
